import api from 'app/shared/utils/api';
import DispatchConstants from 'app/shared/constants/DispatchConstants';
import Statistic from 'app/shared/model/Statistic';

const StatisticsActions = {
    getStats(params = {}) {
        return dispatch => dispatch(api.users.properties.getStats(params))
            .then((result) => {
                if (result.success) {
                    const statisticModel = Statistic(result.response);

                    return dispatch({
                        type: DispatchConstants.STATS_GET_SUCCESS,
                        payload: statisticModel,
                    });
                }
                return dispatch({
                    type: DispatchConstants.STATS_GET_FAIL,
                    payload: result,
                });
            })
            .catch(err => dispatch({
                type: DispatchConstants.STATS_GET_FAIL,
                payload: err,
            }));
    },
};

export default StatisticsActions;
